import { Provider as TooltipProvider } from "@radix-ui/react-tooltip";
import { Suspense } from "react";
import { QueryClientProvider } from "react-query";

import { queryClient } from "../lib/queries";
import { Box } from "../slang";
import Provider from "./AppContextProvider";
import { I18n } from "./I18n";
import Router from "./Router";

import { House, Recycle } from "phosphor-react";
import { ReactQueryDevtools } from "react-query/devtools";
import { BrowserRouter } from "react-router-dom";

import { Button2 } from "../ui/Shared";
import Loading from "./Loading";
import { pageHeight } from "./pageHeight";
import ErrorBoundary from './ErrorBoundary';

pageHeight();

export default function App() {
  return (
    <BrowserRouter>
      <QueryClientProvider client={queryClient}>
        <Provider>
          <ErrorBoundary>
            <I18n>
              <Suspense fallback={<Loading />}>
                <TooltipProvider>
                  <Router />
                </TooltipProvider>
                <ReactQueryDevtools />
              </Suspense>
            </I18n>
          </ErrorBoundary>
        </Provider>
      </QueryClientProvider>
    </BrowserRouter>
  );
}

export function ErrorFallback({ error }: { error: Error }) {
  return (
    <div className="errorWrapper">
      <Box role="alert" className="error-wrapper">
        <span className="text-4xl">
          Sorry! Something went wrong.{" "}
          <span role="img" aria-label="Sad face emoji">
            😔
          </span>
        </span>
        <div className="errorMessage">
          <pre>{error.message}</pre>
        </div>
        <Box flow="column" gap={2}>
          <Button2
            onClick={() => window.location.reload()}
            color="blue"
            leftIcon={<Recycle size={16} />}
          >
            Try again
          </Button2>
          <Button2
            onClick={() => {
              location.href = "/";
            }}
            leftIcon={<House size={16} />}
          >
            Home
          </Button2>
        </Box>
      </Box>
    </div>
  );
}
